import React from "react";
import NotificationBell from "@/components/NotificationBell";

export function PortalHeader({ eyebrow, title, children, testId }) {
  return (
    <div
      className="border-b px-8 py-6 flex items-center justify-between gap-6 sticky top-0 z-30"
      style={{ background: "rgba(11,14,20,0.9)", borderColor: "var(--dt6-border)", backdropFilter: "blur(10px)" }}
      data-testid={testId || "portal-header"}
    >
      <div>
        <div className="font-mono text-[0.7rem] tracking-[0.16em] uppercase text-[color:var(--dt6-muted)]">{eyebrow}</div>
        <h1 className="font-heading text-2xl font-bold mt-1">{title}</h1>
      </div>
      <div className="flex items-center gap-2">
        {children}
        <NotificationBell />
      </div>
    </div>
  );
}

export function PortalBody({ children, testId }) {
  return (
    <div className="p-8" data-testid={testId || "portal-body"}>{children}</div>
  );
}

export function StatTile({ label, value, hint, testId }) {
  return (
    <div className="dt6-card p-5" data-testid={testId}>
      <div className="font-mono text-[0.7rem] tracking-[0.14em] uppercase text-[color:var(--dt6-muted)]">{label}</div>
      <div className="mt-2 font-heading text-3xl font-black">{value}</div>
      {hint && <div className="mt-1 text-xs text-[color:var(--dt6-muted)]">{hint}</div>}
    </div>
  );
}

export function StatusPill({ status }) {
  return (
    <span className="dt6-status" data-status={status || "unknown"}>{(status || "unknown").replace("_"," ")}</span>
  );
}

export function EmptyState({ children, testId }) {
  return (
    <div className="dt6-empty" data-testid={testId}>{children}</div>
  );
}
